require("./bootstrap");
import Alpine from "alpinejs";
import TomSelect from "tom-select";

window.Alpine = Alpine;
Alpine.start();

document.addEventListener("DOMContentLoaded", function () {
    // Init Tom-Select
    if (document.getElementById("search-service")) {
        new TomSelect("#search-service", {
            maxItems: 3,
            plugins: ["remove_button"],
            placeholder: "Ej.: Ploteo, Volante",
        });
    }
});
